/*
    These constants are used only in the embedded client.  They correspond to
    the values that are used in our host/client messaging contracts
*/ (function(constants) {
    constants.initSaasMarketplaceEventName = 'initSaasMarketplace';
    constants.acquireAppEventName = 'acquireSaasApp';
    (function(actionTypes) {
        actionTypes.ctaClicked = 'ctaClicked';
        actionTypes.initListenerFinished = 'initListenerFinished';
        actionTypes.acquireApp = 'acquireApp';
        actionTypes.externalRedirect = 'externalRedirect';
        actionTypes.updateUrl = 'updateUrl';
        actionTypes.closeSaasMarketplace = 'closeSaasMarketplace';
        actionTypes.finishedLoadingContentProviderList = 'contentProvidersLoaded';
    })(constants.actionTypes || (constants.actionTypes = {}));
})(constants || (constants = {}));
export var constants;
